import { fmt } from 'components/IntlWrapper/IntlWrapper';

export const PAYMENT_TYPE = {
  POST_PAID: 'Postpaid',
  PRE_PAID: 'Prepaid'
};

export const CASHOUT_FREQUENCY = {
  WEEKLY: 'Weekly',
  DAILY: 'Daily',
  NEXT_DAY: 'Next Day'
};

export const PAYMENT_SCHEDULE = {
  DAILY: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'],
  WEEKLY_SUN: ['Sunday'],
  WEEKLY_MON: ['Monday'],
  WEEKLY_WED: ['Wednesday'],
  TWO_DAYS: ['Monday', 'Wednesday'],
  THREE_DAYS: ['Sunday', 'Tuesday', 'Thursday']
};

export const FAWRY = 'Fawry';

export const BALANCE_CATEGORIES = {
  CASH_COLLECTION_CYCLE: 0,
  BOSTA_FEES_CYCLE: 1,
  CASH_OUT: 2,
  COMPENSATION: 3,
  PACKING_MATERIAL: 4,
  PACKING_MATERIAL_REFUND: 14,
  TOP_UP: 5,
  REJECTED_CASHOUT: 8,
  BALANCE_ADJUSTMENT_POSITIVE: 9,
  BALANCE_ADJUSTMENT_NEGATIVE: 10,
  BORROW: 11,
  PICKUP_FEES: 13
};

export const FLYER_SIZE = {
  Normal: fmt({ id: 'wallet.cycles.flyer_size.normal' }),
  Large: fmt({ id: 'wallet.cycles.flyer_size.large' }),
  'X-Large': fmt({ id: 'wallet.cycles.flyer_size.x_large' }),
  'White Bag': fmt({ id: 'wallet.cycles.flyer_size.xx_large' }),
  Bulky: fmt({ id: 'wallet.cycles.flyer_size.bulky' }),
  'Light Bulky': fmt({ id: 'wallet.cycles.flyer_size.light_bulky' }),
  'Heavy Bulky': fmt({ id: 'wallet.cycles.flyer_size.heavy_bulky' })
};

export const PAYMENT_TRANSFER_METHOD = {
  FAWRY: 'Fawry',
  BANK_TRANSFER: 'Bank transfer'
};

export const FILTERED_BALANCE_CATEGORIES = {
  'cash-collection': 0,
  'bosta-fees': 1
};

export const SORT_ORDER = {
  ascend: 'asc',
  descend: 'desc'
};

export const WALLET_VIDEO_URL = 'https://www.youtube.com/embed/A6lNH9zNDOk';
export const WALLET_VIDEO_URL_ARABIC =
  'https://www.youtube.com/embed/EIekRBhjW_A';

export const TABLE_PAGE_LIMIT = 50;
export const TABLE_PAGE_SIZE_OPTIONS = [50, 100, 200];

export const PERCENTAGE = 'PERCENTAGE';

export const ALL_PAID = 'All paid';

export const BALANCE_ADJUSTMENT_CATEGORIES = {
  FULFILLMENT_SETTLEMENT: 'Fulfillment Settlement',
  COMPENSATION_VARIANCE: 'Compensation Variance',
  OVERDUE_SETTLEMENT: 'Overdue Settlement',
  COD_SETTLEMENT: 'COD Settlement',
  BORROW_ADJUSTMENT: 'Borrow Adjustment',
  EXTRA_FEES: 'Extra Fees',
  INTERNATIONAL_TRANSFER_FEES: 'International Transfer Fees',
  FULFILLMENT_PALLET_FEES: 'Fulfillment Pallet Fees',
  DONATION: 'Donation',
  FULFILLMENT_STORAGE_FEES: 'Fulfillment Storage Fees',
  PICKUP_FEES_ADJUSTMENT: 'Pick-up Fees Adjustment',
  TRANSFER_FEES: 'Transfer Fees'
};

export const BALANCE_ADJUSTMENT_MAPPING = {
  [BALANCE_ADJUSTMENT_CATEGORIES.FULFILLMENT_SETTLEMENT]:
    'fulfillment_settlement',
  [BALANCE_ADJUSTMENT_CATEGORIES.COMPENSATION_VARIANCE]:
    'compensation_variance',
  [BALANCE_ADJUSTMENT_CATEGORIES.OVERDUE_SETTLEMENT]: 'overdue_settlement',
  [BALANCE_ADJUSTMENT_CATEGORIES.COD_SETTLEMENT]: 'cod_settlement',
  [BALANCE_ADJUSTMENT_CATEGORIES.BORROW_ADJUSTMENT]: 'borrow_adjustment',
  [BALANCE_ADJUSTMENT_CATEGORIES.EXTRA_FEES]: 'extra_fees',
  [BALANCE_ADJUSTMENT_CATEGORIES.INTERNATIONAL_TRANSFER_FEES]:
    'international_transfer_fees',
  [BALANCE_ADJUSTMENT_CATEGORIES.FULFILLMENT_PALLET_FEES]:
    'fulfillment_pallet_fees',
  [BALANCE_ADJUSTMENT_CATEGORIES.DONATION]: 'donation',
  [BALANCE_ADJUSTMENT_CATEGORIES.FULFILLMENT_STORAGE_FEES]:
    'fulfillment_storage_fees',
  [BALANCE_ADJUSTMENT_CATEGORIES.PICKUP_FEES_ADJUSTMENT]:
    'pickup_Fees_adjustment',
  [BALANCE_ADJUSTMENT_CATEGORIES.TRANSFER_FEES]: 'transfer_fees'
};

export const SIZES_SORT_WEIGHT = {
  Bulky: 6,
  Normal: 0,
  'White Bag': 3,
  'X-Large': 2,
  'Light Bulky': 4,
  Large: 1,
  'Heavy Bulky': 5
};

export const COMPENSATION_DEPARTMENTS_MAPPER = {
  OPs: 'OPs',
  Fleet: 'Delivery Experience',
  Experience: 'Investigation',
  CS: 'CS',
  'AM (Red)': 'AM (Red)',
  'AM (Silver/Gold)': 'AM (Silver/Gold)',
  'AM (New B.Lines)': 'Sales'
};

export const COMPENSATION_INVESTIGATION_REASONS = [
  'Agent mistake',
  'Playbook',
  'Less than 100 LE',
  'Social media',
  'First incident',
  'Insurance',
  'Fulfillment',
  'Tech issue'
];

export const COMPENSATION_DEPARTMENTS_NAMES = {
  INVESTIGATION: 'Experience'
};

export const renderCashoutTooltip = (frequency, daysSchedule) => {
  const { NEXT_DAY, DAILY } = CASHOUT_FREQUENCY;

  const tooltip = [NEXT_DAY, DAILY].includes(frequency)
    ? 'wallet.balance.header.cashout.cashout_frequency_daily_tooltip'
    : daysSchedule.length === 2
    ? 'wallet.balance.header.cashout.cashout_frequency_two_days_week_tooltip'
    : daysSchedule.length === 3
    ? 'wallet.balance.header.cashout.cashout_frequency_three_days_week_tooltip'
    : 'wallet.balance.header.cashout.cashout_frequency_weekly_wednesday_tooltip';

  return fmt({ id: tooltip });
};

export const renderCashoutFrequencyValue = (frequency, daysSchedule) => {
  const { NEXT_DAY, DAILY } = CASHOUT_FREQUENCY;

  const tooltip = [NEXT_DAY, DAILY].includes(frequency)
    ? 'wallet.balance.header.cashout.cashout_frequency_next_day'
    : daysSchedule.length === 2
    ? 'wallet.balance.header.cashout.cashout_frequency_two_days_week'
    : daysSchedule.length === 3
    ? 'wallet.balance.header.cashout.cashout_frequency_three_days_week'
    : 'wallet.balance.header.cashout.cashout_frequency_weekly';

  return fmt({ id: tooltip });
};

export const EXCHANGE_COUNTRY_OPTIONS = {
  SA: 'sa',
  AE: 'ae'
};

export const INTERNATIONAL_COUNTRY_CURRENCY_ID = {
  EG: 'common.SAR_amount',
  AE: 'common.aed_amount'
};

export const CUSTOMS_VAT_TYPE = {
  DDU: 'DDU',
  DDP: 'DDP'
};

export const EMPTY_STATE_IMAGES = {
  FINANCIAL_VISIBILITY: 'FINANCIAL_VISIBILITY',
  TRACK_CASH: 'TRACK_CASH',
  CASHOUT_DATE: 'CASHOUT_DATE'
};

export const EMPTY_STATE_SECTIONS = [
  {
    key: EMPTY_STATE_IMAGES.FINANCIAL_VISIBILITY,
    title: fmt({ id: 'wallet.balance.empty_state.financial_visibility_title' }),
    subTitle: fmt({
      id: 'wallet.balance.empty_state.financial_visibility_sub_title'
    })
  },
  {
    key: EMPTY_STATE_IMAGES.TRACK_CASH,
    title: fmt({ id: 'wallet.balance.empty_state.track_cash_title' }),
    subTitle: fmt({ id: 'wallet.balance.empty_state.track_cash_sub_title' })
  },
  {
    key: EMPTY_STATE_IMAGES.CASHOUT_DATE,
    title: fmt({ id: 'wallet.balance.empty_state.cashout_date_title' }),
    subTitle: fmt({ id: 'wallet.balance.empty_state.cashout_date_sub_title' })
  }
];

export const ADJUSTMENT_TYPE = {
  BALANCE: 'Balance',
  CREDITS: 'Credits'
};

export const CREDITS_TEMPLATE_SAVE_NAME = 'Credits Adjustment template.xlsx';

export const BOSTA_CREDIT_FEAT_TOGGLE = 'isBostaCreditsEnabled';

export const BOSTA_CREDITS_TOGGLE_CONTEXT = {
  ADD_BOSTA_CREDIT_ADJUSTMENT: 'ADD_BOSTA_CREDIT_ADJUSTMENT',
  LIMIT_ORDER_AND_PICKUP_CREATION: 'LIMIT_ORDER_AND_PICKUP_CREATION'
};

export const DD_MM_YYYY = 'DD-MM-YYYY';
export const YYYY_MM_DD = 'YYYY-MM-DD';

export const ACH_MAX_FILES_COUNT = 10;

export const RECHARGE_TYPE = {
  BOSTA_CREDITS: 'bosta credit',
  WALLET: 'wallet'
};

export const RECHARGE_OPTIONS = {
  BANK_TRANSFER: {
    value: 'BANK_TRANSFER',
    label: fmt({
      id: 'account_locked.body.bank_option.title'
    })
  },
  FAWRY_TRANSFER: {
    value: 'FAWRY_TRANSFER',
    label: fmt({
      id: 'account_locked.body.fawry_option.title'
    })
  }
};

export const FILE_TYPE = {
  PDF: 'application/pdf'
};
